import React, { FC } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import {
  Notification as NotificationT,
  NotificationGroup,
  NotificationCallbacks,
} from 'api/notifications';
import { localStorageWorkspacePath } from 'components/organisms/image-preview';
import { useLocalStorageSession } from 'hooks/use-local-storage-session';
import { renderMessage } from './message';
import { Timestamp } from './timestamp';

const Message = styled.div`
  display: flex;
  flex: 0 0 75%;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-wrap: wrap;
  gap: var(--spacing-02);
`;

const Container = styled.div`
  display: flex;
  flex: 1 1 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Primary: FC<{
  group: NotificationGroup;
  notification: NotificationT;
  open: () => void;
  callbacks?: NotificationCallbacks;
}> = ({ group, notification, open, callbacks }) => {
  const { pathname } = useLocation();
  const { setItem } = useLocalStorageSession(
    localStorageWorkspacePath,
    pathname,
  );

  return (
    <Container>
      <Message>
        {renderMessage(group, notification, open, setItem, callbacks)}
      </Message>
      <Timestamp timestamp={notification.timestamp} />
    </Container>
  );
};
